<script>
    import store from '../../../../script/store/checkout';

    export default {
        name: 'CheckoutPaymentMethod',

        props: {
            forceActive: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                storeState: store.state,
                isActive: this.forceActive,
            };
        },

        watch: {
            description(to) {
                if (this.isActive) {
                    this.storeState.payment.description = to;
                }
            },

            isActive: {
                immediate: true,
                handler(to) {
                    if (to) {
                        this.storeState.payment.description = this.description;
                        this.storeState.payment.payloadBuilder = this.submit;
                    }
                },
            },
        },

        activated() {
            if (this.forceActive) return;
            this.isActive = true;
        },

        deactivated() {
            if (this.forceActive) return;
            this.isActive = false;
        },
    };
</script>
